import React from 'react';
import { Box, Flex, Heading, Text } from '@apia/theme';
import useContext from '../../../../hooks/useContext';
import IProperty from '../../../../JSApi/constants/IProperty';
import DontAsk from '../../../common/DontAsk';
import { ApiaComponentContextPrimitive } from '../apiaComponent/ApiaComponentContext';
import { useFieldContext } from '../fieldsStore/FieldContext';
import Scheduler from '../scheduler/Scheduler';
import MakeField from '../fieldsStore/MakeField';
import useApiaFieldCommonProps from './useApiaFieldCommonProps';
import usePropsSelector from '../../../../store/propsStore/usePropsSelector';
import Templater from '../../../../templater/Templater';

const ApiaText = MakeField(
  React.forwardRef((): JSX.Element => {
    const { fieldId } = useContext(ApiaComponentContextPrimitive);
    const props = usePropsSelector(fieldId);
    const {
      state: { value },
    } = useFieldContext();
    const { identifier } = useApiaFieldCommonProps({
      className: 'text__field',
    });

    // si es agenda
    if (value && String(value).indexOf('schedContainer') !== -1) {
      const schedulerValue = String(value);
      let start = 0;
      let end = 0;
      if (schedulerValue) {
        start = schedulerValue?.indexOf('loadSchedExec');
        start += 14;

        end = schedulerValue?.indexOf(';</div>');
        end -= 1;

        const strParts = schedulerValue
          ?.slice(start, end)
          .replaceAll(`'`, ``)
          .replaceAll(' ', '');
        const arrParts = strParts.split(',');

        const schId = arrParts[1];
        const proId = arrParts[2];
        const proVerId = arrParts[3];
        const tskId = arrParts[4];
        const showDisponibility = arrParts[5];

        const showAttributes = arrParts[6];
        return (
          <Scheduler
            url="/apia.design.TaskSchedulerAction.run"
            schId={schId}
            proId={proId}
            proVerId={proVerId}
            tskId={tskId}
            showDisponibility={showDisponibility}
            showAttributes={showAttributes}
          />
        );
      }
      return <Heading as="h1">Error con datos de agenda</Heading>;
    }

    if (value && /^{{!template}}/.test(String(value))) {
      const component = Templater.parseString(
        String(value).replace('{{!template}}', ''),
      );
      return <Box {...identifier}>{component}</Box>;
    }

    if (value && /<\/?[a-z][^>]*>/i.test(String(value))) {
      // it is HTML
      return (
        <DontAsk
          title={props[IProperty.PROPERTY_TOOLTIP]}
          dontDoItHTML={String(value)}
          sx={{
            alignItems: 'center',
            height: '100%',
          }}
          {...identifier}
        />
      );
    }

    return (
      <Flex
        {...window.getVariant('layout.execution.form.fields.text')}
        className="text__field"
        sx={{
          display: props[IProperty.PROPERTY_VISIBILITY_HIDDEN]
            ? 'none'
            : 'flex',
        }}
      >
        <Text
          sx={{
            fontWeight: props[IProperty.PROPERTY_BOLD] ? 'bold' : 'normal',
            textDecoration: props[IProperty.PROPERTY_UNDERLINED]
              ? 'underline'
              : 'none',
            color: props[IProperty.PROPERTY_FONT_COLOR],
            textAlign:
              (props[IProperty.PROPERTY_ALIGNMENT] === '1' ? 'center' : null) ||
              (props[IProperty.PROPERTY_ALIGNMENT] === '2' ? 'right' : null),
          }}
          {...identifier}
        >
          {(value || props[IProperty.PROPERTY_VALUE]) as string}
        </Text>
      </Flex>
    );
  }),
  {
    doSynchronize: () => true,
  },
);

export default ApiaText;
